import React, {FunctionComponent, useEffect, useState} from 'react';
import { addItemToCart, getCart, removeItemCart } from '../cart/CartAction';
import Icons from './Icons';
import { Cart } from './iMonCompte';
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { getHostApi, getRequestConfig } from '../../utils';
import { BounceLoader } from './BounceLoader';

interface ButtonReOrderProps {
  shopRef: string;
  items: Cart[];
}

const ButtonReOrder: FunctionComponent<ButtonReOrderProps> = ({items, shopRef}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [featureIsEnabled, setEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    axios.get(`${getHostApi()}/shops/features/reorder_${shopRef.toLowerCase()}`, getRequestConfig())
      .then(response => setEnabled(response.data.feature));
  }, []);

  const handleClickAccept = async () => {
    setLoading(true);
    const arrayItems = [];
    const arrayItemsAdded = [];
    for (const item of items) {
      const object: any = {
        article_id: item.idarticles_,
        quantite: item.Quantite
      };
      arrayItems.push(object);
    }
    for (const item of arrayItems) {
      const response = await addItemToCart(item);
      arrayItemsAdded.push(response.item.id);
    }
    let errored = false;

     // Verification si les articles ajouté ne casse pas le panier
    try {
      await getCart();
    } catch (e) {
      errored = true;
      for (const item of arrayItemsAdded) {
        await removeItemCart(item);
      }
    } finally {
      setLoading(false);
      setError(errored);
    }

    if (!errored) {
      toggleShowModal();
      window.location.href = '/monpanier.php';
    }
  }

  const toggleShowModal = () => setShowModal(!showModal);

  return (
    <div style={{display: 'inline-block'}}>
      {(featureIsEnabled && !error) && (
        <button
          className="d-flex align-items-center black cursor-pointer border-black p-2 bg-white text-center mt-3"
          style={{ borderRadius: '30px', border: '1px solid' }}
          onClick={toggleShowModal}
        >
          <span className="pr-1"><Icons icon="cart" size={20} color="#333" /></span>
          <span>Repasser cette commande</span>
        </button>
      )}
      <Modal
        classNames={{ overlay: 'bootstrap-container' }}
        open={showModal}
        closeOnOverlayClick={false}
        onClose={toggleShowModal}
        center
      >
        {!error && (
          <>
            <p className="bold text-underline font18">
              Voulez-vous ajouter les articles de cette commande dans votre panier ?
            </p>
            <button
              className="border-0 bold bg-white1 cursor-pointer btnCancelModal float-left py-2 px-3"
              title="Annuler"
              disabled={loading}
              onClick={toggleShowModal}
            >
              Non
            </button>
            <button
              className="border-dark bold bg-white1 cursor-pointer btnValidateModal float-right py-2 px-3"
              title="Repasser la commande"
              disabled={loading}
              onClick={handleClickAccept}
            >
              <BounceLoader loading={loading} />
              {!loading && 'Oui'}
            </button>
          </>
        ) || (
          <p className="font18 text-center p-4">
            <span className="bold">Cette commande n'est malheureusement pas éligible à cette fonctionnalitée.</span>
            <br />
            Veuillez nous excuser pour le désagrément occasionné.
          </p>
        )}
      </Modal>
    </div>
  );
};

export default ButtonReOrder;